'use strict';

var address = require('./pages/checkout/address'),
	loqate = require('./loqate'),
	formPrepare = require('./pages/checkout/formPrepare'),
	linchpin = require('int_googletagmanager/linchpin/emailsignup'),
	optinout = require('./optinout'),
	reCaptcha = require('int_recaptcha/recaptcha');

var isFormSubmitted = false;

function initializeEvent () {

	var linchpinAnalitics = function(e) {
		// GTM Linchpin analytics
		try {
			if (SitePreferences.GTM_ENABLED) {
				linchpin.guestCheckoutEmailSignup(e);
			}
		} catch (error) {
			window.console.warn(error);
		}
	};

	var submitHandler = function (event) {
		// Prevents multiple registration form submission
		var $form = $('#RegistrationForm');

		if (!$form.valid()) {
			reCaptcha.resetRecaptchaForms();
			return false;
		}

		if (!isFormSubmitted) {
			isFormSubmitted = true;
			linchpinAnalitics(event);
		} else {
			event.preventDefault();
			return false;
		}
	};

	if ($('#RegistrationForm').length > 0) {
		$('#RegistrationForm').on('submit', submitHandler);
		reCaptcha.initRecaptchaOnForm('#RegistrationForm', function() {
			$('#RegistrationForm').trigger('submit');
		});
		updatePasswordRulesState();
	}
}

function updatePasswordRulesState() {
	var $passwordEl = $('#RegistrationForm').find("[id$='password']");

	if ($passwordEl.length && $('.validation-rule').length) {
		$passwordEl.on('input keyup', function() {
			var password = $passwordEl.val();
			var $lengthRule = $('.validation-rule[data-rule="length"]');
			var $numberRule = $('.validation-rule[data-rule="number"]');
			if ($lengthRule.length) {
				var hasLength = password.length >= 8;
				$lengthRule.toggleClass('valid', hasLength).toggleClass('invalid', !hasLength);
			}
			if ($numberRule.length) {
				var hasNumber = /\d/.test(password);
				$numberRule.toggleClass('valid', hasNumber).toggleClass('invalid', !hasNumber);
			}
		});
	}
}

exports.init = function () {
	initializeEvent();

	var $registrationForm = $('#RegistrationForm');
	if ($registrationForm.find('[name$="country"]').length) {
		address.dynamicAddressFieldsHandler($registrationForm);
	}
	if ($registrationForm.find('[id$="_addressFind"]').length) {
		loqate.init($registrationForm);
	}

	optinout.init();

	formPrepare.init({
		continueSelector: '[name$="profile_confirm"]',
		formSelector: '#RegistrationForm',
		replaceInvalidInput: true,
		autofillValidate: true,
		keyup: false
	});
};
